import { createAction, props } from '@ngrx/store';

export const pageTitleActions = {
  changePageTitle: createAction(
    '[PageTitle] Change Page Title',
    props<{ title: string, interpolateParams?: object }>()
  )
};
